const HeroSection = () => {
  return (
    <section className="relative w-full h-[700px] md:h-screen bg-landing-page-hero bg-cover bg-center">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-[#F5E9D7]/70 md:from-[#F5E9D7] to-[#F5E9D7]/70 md:to-[#F5E9D7]/0 flex items-center justify-center lg:justify-start">
            <div className="relative xs:w-full w-[80%] lg:w-[50%] h-[50%] flex flex-col items-center lg:items-start justify-center lg:pl-[100px] 3xl:pl-[150px] sm:mt-[70px] 2xl:mt-0 3xl:mt-10">
                <h1 className="text-[60px] sm:text-[80px] xl:text-[100px] font-bold font-playfair text-[#714E16] text-center md:text-start">Fresh & <br></br> Delicious</h1>
                <p className="xs:text-md text-lg sm:text-xl font-semibold font-montserrat text-center md:text-start">From our oven to your heart</p>
                <a href="about">
                  <button className="bg-[#41220E] xs:px-[40px] px-[50px] sm:px-[60px] xs:py-2 py-4 rounded-xl font-bold text-[#F5E9D7] xs:text-[18px] text-[20px] sm:text-[22px] mt-8">Discover</button>
                </a>
            </div>
        </div>
    </section>

  )
}

export default HeroSection
